// START_MODULE application_entrypoint
// START_CONTRACT
// PURPOSE: Mount the Tomsk Data Science application with its global and responsive styles.
// OPERATIONAL_CONTEXT: Browser entrypoint loaded once by Create React App.
// CONTRACT: Render App inside routing and theme providers;
// load desktop styles before mobile overrides.
// KEYWORDS: react, entrypoint, responsive-styles, providers
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import App from './App';
import ThemeProviderStyledComponents from './theme/ThemeProviderStyledComponents';

import './index.css';
import './mobile.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <HashRouter>
    <ThemeProviderStyledComponents>
      <App />
    </ThemeProviderStyledComponents>
  </HashRouter>,
);
// END_MODULE application_entrypoint
